
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layer } from 'office-ui-fabric-react/lib/Layer';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { mergeStyleSets } from '@uifabric/merge-styles';

import {
    ERROR_CLEAR_ACTION_TYPE
} from '../sagas/operationStatus';

const OperationStatusLayer = (props) => {
    const classNames = mergeStyleSets({
        root: {
            backgroundColor: '#ffffff'
        }
    });

    return (
        <Layer>
            <div className={classNames.root}>
                <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={false}
                    onDismiss={() => {
                        if (props.clearError) {
                            props.clearError();
                        }
                    }}
                    dismissButtonAriaLabel="Zavřít"
                >
                    Při zpracování požadavku došlo k chybě.
                </MessageBar>
            </div>
        </Layer>
    );
}

const StartLayer = (props) => {
    const classNames = mergeStyleSets({
        root: {
            backgroundColor: 'rgba(255,255,255,0)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: '4px'
        },
        info: {
            width: '400px',
            padding: '8px',
            backgroundColor: '#cccccc',
            textAlign: 'center'
        }
    });

    return (
        <Layer>
            <div className={classNames.root}>
                <div className={classNames.info}>{props.operation}...</div>
            </div>
        </Layer>
    );
}

const InfoLayer = (props) => {
    const classNames = mergeStyleSets({
        root: {
            backgroundColor: 'rgba(255,255,255,0)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: '4px'
        },
        info: {
            width: '400px',
            padding: '8px',
            backgroundColor: '#dff6dd',
            textAlign: 'center'
        }
    });

    return (
        <Layer>
            <div className={classNames.root}>
                <div className={classNames.info}>{props.operation} bylo dokončeno.</div>
            </div>
        </Layer>
    );
}

const WarningLayer = (props) => {
    const classNames = mergeStyleSets({
        root: {
            backgroundColor: 'rgba(255,255,255,0)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: '4px'
        },
        warning: {
            width: '500px',
            padding: '8px',
            backgroundColor: '#ffb900',
            textAlign: 'center'
        },
        messages: {
            textAlign: 'left',
            paddingLeft: '50px',
            paddingTop: '8px'
        }
    });

    return (
        <Layer>
            <div className={classNames.root}>
                <div className={classNames.warning}>
                    <div>{props.operation.title} nebylo možné dokončit z následujících důvodů:</div>
                    <div className={classNames.messages}>
                        {props.operation.messages.map(item => {
                            return (
                                <div key={item.id}>- {item.title}</div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Layer>
    );
}

const OperationStatus = (props) => {

    const dispatch = useDispatch();

    const clearError = () => dispatch({
        type: ERROR_CLEAR_ACTION_TYPE
    });

    const operationStatus = useSelector(state => {
        return state.operationStatus;
    });

    let component = null;
    if (operationStatus.operationStart) {
        component = (
            <StartLayer
                operation={operationStatus.operationStart}
            />
        );
    }

    if (operationStatus.operationSuccess) {
        component = (
            <InfoLayer
                operation={operationStatus.operationSuccess}
            />
        );
    }

    if (operationStatus.operationNotSuccess) {
        component = (
            <WarningLayer
                operation={operationStatus.operationNotSuccess}
            />
        );
    }

    if (operationStatus.errors.length > 0) {
        component = <OperationStatusLayer clearError={clearError} />;
    }
    return component;
}

export default OperationStatus;
